/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import loginReducer from "./loginReducer";
import resetPasswordReducer from "./resetPasswordReducer";
import assetListReducer from "./assetListReducer";
import assetReducer from "./assetReducer";
import dashboardReducer from "./dashboardReducer";
import userDetailReducer from "./userDetailReducer";
import deleteAssetReducer from "./deleteAssetReducer";
import uploadReducer from "./uploadReducer";
import accountReducer from "./accountReducer";
import accountLinkReducer from "./accountLinkReducer";
import transactionReducer from "./transactionReducer";
import cmsReducer from "./cmsReducer";
import attachmentReducer from "./attachmentReducer";
import notificationReducer from "./notificationReducer";
// import mortgageReducer from './mortgageReducer';
import sidebarReducer from "./sidebarReducer";
import contactsReducer from "./contactsReducer";
import assetSlugReducer from "./assetSlugReducer";
import assetBasicInfoReducer from "./assetBasicInfoReducer";
import assetInvestmentInfoReducer from "./assetInvestmentInfoReducer";
import assetMediaReducer from "./assetMediaReducer";
import assetFinancialReducer from "./assetFinancialReducer";
import accountDetailReducer from "./accountDetailReducer";
import assetExpensesReducer from "./assetExpensesReducer";
import assetIncomesReducer from "./assetIncomesReducer";
import assetValuationReducer from "./assetValuationReducer";
import statsReducer from "./statsReducer";
import checkAssetReducer from "./checkAssetReducer";
import resourcesReducer from "./resourcesReducer";
import recommendationReducer from "./recommendationReducer";
import exportToExcel from "./exportReducer";
import chatReducer from "./chatReducer";
import inviteReducer from "./inviteReducer";
import dealReducer from "./dealReducer";
import checklistReducer from "./checklistReducer";
import propParser from "./propParser";
import reminderReducer from "./reminderReducer";
import missingImportReducer from "./missingImportReducer";
import partnerReducer from "./partnerReducer";
import ThemeOptions from "./themeOptions";
import { assetsAddModal } from "./assetsAddModal";
import { opportunitiesReducer } from "./opportunities";
import permissionReducer from "./permissionReducer";
import dashboardFilterReducer from "./dashboardFilterReducer";
import filterReducer from "./filterReducer";
import importerReducer from "./importerReducer";
import importerParseReducer from "./importerParseReducer";
import integrationReducer from "./integrationReducer";

const rootReducer = (history) =>
  combineReducers({
    login: loginReducer,
    // forgotPassword: forgotPasswordReducer,
    resetPassword: resetPasswordReducer,
    assetList: assetListReducer,
    asset: assetReducer,
    router: connectRouter(history),
    dashboard: dashboardReducer,
    userDetail: userDetailReducer,
    deleteAssetReducer: deleteAssetReducer,
    upload: uploadReducer,
    plaid: accountReducer,
    accountLink: accountLinkReducer,
    transactions: transactionReducer,
    // resendEmail: resendEmailReducer,
    cms: cmsReducer,
    attachments: attachmentReducer,
    notifications: notificationReducer,
    // mortgage: mortgageReducer,
    sidebar: sidebarReducer,
    contacts: contactsReducer,
    assetSlug: assetSlugReducer,
    assetBasicInfo: assetBasicInfoReducer,
    assetInvestmentInfo: assetInvestmentInfoReducer,
    assetMedia: assetMediaReducer,
    financial: assetFinancialReducer,
    assetAccountDetail: accountDetailReducer,
    assetExpenses: assetExpensesReducer,
    assetIncomes: assetIncomesReducer,
    assetValuation: assetValuationReducer,
    statsReducer: statsReducer,
    checkAsset: checkAssetReducer,
    resources: resourcesReducer,
    recommendations: recommendationReducer,
    exportToExcel: exportToExcel,
    chat: chatReducer,
    invite: inviteReducer,
    deal: dealReducer,
    checklist: checklistReducer,
    propParser,

    reminders: reminderReducer,
    missingImport: missingImportReducer,
    partners: partnerReducer,
    ThemeOptions,
    opportunities: opportunitiesReducer,

    assetsAddModal,
    permission: permissionReducer,
    dashboardFilter: dashboardFilterReducer,
    filter: filterReducer,
    importers: importerReducer,
    importerParsedData: importerParseReducer,
    integrations: integrationReducer,
  });

export default rootReducer;
